export const STATUS_COLORS = {
    'Rascunho': 'blue',
    'Em Cotação': 'orange',
    'Concluída': 'green',
    'Cancelada': 'purple',
    'Prazo Encerrado': 'error'
};

export const STATUS_ICONS = {
    'Rascunho': 'mdi mdi-file-document-outline',
    'Em Cotação': 'mdi mdi-selection-ellipse',
    'Concluída': 'mdi mdi-check-circle-outline',
    'Cancelada': 'mdi mdi-folder-remove-outline',
    'Prazo Encerrado': 'mdi mdi-clock-outline'
};

export const DECISAO_COLORS = {
    'Ganhadores definidos': 'success',
    'Ganhadores parciais': 'orange',
    'Não Iniciada': 'blue'
};

export const SITUACAO_COLORS = {
    'Todos gerados': 'success',
    'Parciais': 'orange',
    'Não gerados': 'blue'
};

export const DIAS_SEMANA_MAP = {
    0: 'domingo',
    1: 'segunda',
    2: 'terca',
    3: 'quarta',
    4: 'quinta',
    5: 'sexta',
    6: 'sabado'
};

export const DIAS_SEMANA_REVERSE_MAP = {
    'domingo': 0,
    'dom': 0,
    'segunda': 1,
    'seg': 1,
    'terca': 2,
    'ter': 2,
    'quarta': 3,
    'qua': 3,
    'quinta': 4,
    'qui': 4,
    'sexta': 5,
    'sex': 5,
    'sabado': 6,
    'sab': 6
};

export const API_ENDPOINTS = {
    // Listagem
    LISTAR_COTACOES: '/cotacao/listar_todas_cotacoes',
    SINCRONIZAR_FORNECEDORES: '/cotacao/sincronizar_fornecedores_participantes',

    // CRUD Cotação
    BUSCAR_DETALHES: '/cotacao/criar_cotacao_buscar_detalhes_cotacao',
    ATUALIZAR_COTACAO: '/cotacao/criar_cotacao_atualizar_cotacao',
    PUBLICAR_COTACAO: '/cotacao/criar_cotacao_publicar_cotacao',
    DELETAR_COTACAO: '/cotacao/criar_cotacao_deletar_cotacao',

    // Dados auxiliares
    LISTAR_EMPRESAS: '/cotacao/criar_cotacao_listar_empresa_filial',
    LISTAR_SEGUIDORES: '/cotacao/criar_cotacao_listar_seguidores_cotacao',
    LISTAR_SEGUIDORES_FAVORITOS: '/cotacao/criar_cotacao_listar_seguidores_cotacao_favoritos',

    // Produtos
    ATUALIZAR_PRODUTOS: '/cotacao/atualizar_produtos_cotacao'
};

export const TABS = [
    { key: 'todas', name: 'Todas' },
    { key: 'em_cotacao', name: 'Em Cotação' },
    { key: 'rascunho', name: 'Rascunho' },
    { key: 'cancelada', name: 'Cancelados' }
];

export const PAGINATION = {
    DEFAULT_LIMIT: 300,
    DEFAULT_OFFSET: 0
};

export const ERROR_MESSAGES = {
    LOAD_COTACOES: 'Não foi possível carregar as cotações!',
    LOAD_COTACAO: 'Não foi possivel encontrar cotação!',
    SAVE_RASCUNHO: 'Não foi possível salvar o rascunho.',
    PUBLICAR_COTACAO: 'Não foi possível publicar a cotação.',
    DELETE_COTACAO: 'Não foi possível descartar o rascunho.',
    TITULO_REQUIRED: 'Informe um título para a cotação.',
    PERIODO_INVALID: 'Período de recebimento inválido.',
    PRODUTOS_REQUIRED: 'Adicione ao menos um produto à cotação.',
    FORNECEDORES_REQUIRED: 'Adicione ao menos um fornecedor à cotação.',
    LOCAIS_REQUIRED: 'Adicione ao menos um local de recebimento.',
    PRAZO_ENTREGA_DESEJADO_REQUIRED: 'Informe o prazo de entrega desejado (dias).',
    LEMBRETE_DIARIO_DIAS_REQUIRED: 'Informe a quantidade de dias para o lembrete (0–30).',
    LEMBRETE_DIARIO_DIAS_INVALID: 'Informe um valor entre 0 e 30.',
    CONFIG_REQUIRED: 'Preencha o período de recebimento e selecione uma filial.'
};

export const SUCCESS_MESSAGES = {
    SAVE_RASCUNHO: 'Rascunho atualizado com sucesso!',
    PUBLICAR_COTACAO: 'Cotação publicada com sucesso!',
    DELETE_COTACAO: 'Rascunho descartado com sucesso!'
};

export const getStatusName = (statusName) => STATUS_COLORS[statusName] || 'Desconhecido';
export const getStatusColor = (statusName) => STATUS_COLORS[statusName] || 'grey';
export const getStatusIcon = (statusName) => STATUS_ICONS[statusName] || 'mdi mdi-help-circle-outline';
export const getDecisaoColor = (decisaoName) => DECISAO_COLORS[decisaoName] || 'orange';
export const getSituacaoColor = (situacaoName) => SITUACAO_COLORS[situacaoName] || 'blue';
